<template>
	<v-layout row justify-center>
			
		<v-dialog v-model="value" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
			<v-card flat>
				<v-toolbar dark color="gradiente">
					<v-btn icon dark @click="close">
						<v-icon>close</v-icon>
					</v-btn>
				</v-toolbar>
				<v-toolbar height="90" v-if="visit">
					<v-flex xs12 md3 lg3 px-4>
						<v-toolbar-title>Detalle de la cita</v-toolbar-title>
					</v-flex>
					<v-flex xs12 md3 lg3 class="titleSearch">
						<v-text-field flat label="Buscar" append-outer-icon="search" clearable solo-inverted hide-details @click:append-outer="filterSearch(false)" @click:clear="filterSearch(true)" @keyup.enter="filterSearch(false)" v-model="search" />
					</v-flex>
				</v-toolbar>
				<v-toolbar height="130">
					<v-flex xs12 md3 lg3>
						<v-list light style="background-color: transparent">
							<div class="padding-side">
								<v-text-field :value="visit ? visit.name : ''" rows="1" row-height="24" auto-grow prepend-icon="title" disabled />
							</div>
						</v-list>
					</v-flex>
					<v-flex xs12 md3 lg3>
						<v-list light style="background-color: transparent">
							<v-list-tile avatar>
								<v-list-tile-avatar>
									<v-icon class="red--text">account_circle</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>
										{{ `Host${visit.hosts !== null 
												? visit.hosts.length > 1 ? 's' : ''
												: ''
											}` 
										}}
									</v-list-tile-title>
									<div class="tooltip_trigger">
										{{ visit.hosts !== null 
											?`${visit.hosts.map((e)=> (` ${e.firstName} ${e.lastName}`))}`
											:`${visit.customVisitHosts.map((e)=> (` ${e.name}`))}`
										}}
									</div>
									<div class="custom_tooltip">
										<div v-if="visit.hosts !== null ">
											<p v-for="host in visit.hosts">{{ ` ${host.firstName} ${host.lastName}` }}</p>
										</div>
										<div v-else>
											<p v-for="host in visit.customVisitHosts">{{ ` ${host.name}` }}</p>
										</div>
									</div>
								</v-list-tile-content>
							</v-list-tile>
							<v-list-tile avatar>
								<v-list-tile-avatar>
									<v-icon class="red--text">subject</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>Asunto</v-list-tile-title>
									<v-list-tile-sub-title v-if="visit">{{ visit.reason }}
									</v-list-tile-sub-title>
									<v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
					</v-flex>
					<v-flex xs12 md3 lg3>
						<v-list light style="background-color: transparent">
							<v-list-tile avatar>
								<v-list-tile-avatar>
									<v-icon class="red--text">person</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>Invitados</v-list-tile-title>
									<v-list-tile-sub-title v-if="visit">
										{{ visit.peopleCount }}
									</v-list-tile-sub-title>
									<v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>

							<v-list-tile avatar v-if="visit && visit.visitType=='ONLY_ONCE'">
								<v-list-tile-avatar>
									<v-icon class="red--text">date_range</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>Fecha</v-list-tile-title>
									<v-list-tile-sub-title v-if="visit">
                    {{ visit.date | formatDate }}
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
							<v-list-tile avatar v-if="visit && visit.visitType=='RANGE'">
								<v-list-tile-avatar>
									<v-icon class="red--text">today</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>Fecha inicio</v-list-tile-title>
									<v-list-tile-sub-title v-if="visit">
                    {{ visit.startDate | formatDate }}
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>

						</v-list>
					</v-flex>

					<v-flex xs12 md3 lg3 v-if="visit && visit.visitType=='RANGE'">
						<v-list light style="background-color: transparent">
							<v-list-tile avatar >
								<v-list-tile-avatar>
								</v-list-tile-avatar>
								<v-list-tile-content>
								</v-list-tile-content>
							</v-list-tile>
							<v-list-tile avatar>
								<v-list-tile-avatar>
									<v-icon class="red--text">event</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>Fecha fin</v-list-tile-title>
									<v-list-tile-sub-title v-if="visit">
                    {{ visit.endDate | formatDate }}
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>

						</v-list>
					</v-flex>
	
					<v-speed-dial key="1" absolute bottom left direction="bottom" open-on-hover transition="scale-transition" style="bottom: 0; z-index: 99999">
						<template v-slot:activator>
	              <v-tooltip right>
	                <template v-slot:activator="{ on }">
	                  <v-btn
	                    style="z-index: 99"
	                    color="gradiente"
	                    dark
	                    fab
	                    :small="$vuetify.breakpoint.xsOnly"
	                    v-on="on"
	                  >
	                    <v-icon>more_vert</v-icon>
	                  </v-btn>
				</template>
                <span>Opciones de invitados</span>
              </v-tooltip>
            </template>
            <v-tooltip right>
              <v-btn
                style="z-index: 99"
                fab
                dark
                small
                color="gradiente"
                slot="activator"
                @click="linkParent"
              >
                <v-icon>link</v-icon>
              </v-btn>
              <span>Añadir tutores</span>
            </v-tooltip>
            <v-tooltip right>
              <v-btn
                style="z-index: 999999"
                fab
                dark
                small
                color="gradiente"
                slot="activator"
                @click="addVisitPerson"
              >
                <v-icon>person</v-icon>
              </v-btn>
              <span>Añadir invitado externo</span>
            </v-tooltip>
            <v-tooltip right>
              <v-btn
                style="z-index: 999"
                fab
                dark
                small
                color="gradiente"
                slot="activator"
                @click="sendNotifications()"
              >
                <v-icon>send</v-icon>
              </v-btn>
              <span>Enviar invitaciones</span>
            </v-tooltip>
            <v-tooltip right v-if="hasAnyPollAnswer">
              <v-btn
                style="z-index: 99"
                fab
                dark
                small
                color="gradiente"
                slot="activator"
                @click="downloadPollGeneral()"
              >
                <v-icon>download</v-icon>
              </v-btn>
              <span>Descargar encuestas generales</span>
            </v-tooltip>
			 <v-tooltip right>
              <v-btn
                style="z-index: 999"
                fab
                dark
                small
                color="gradiente"
                slot="activator"
               @click="generateAllEtiqueta(visitPerson)"
              >
                <v-icon>badge</v-icon>
              </v-btn>
              <span>Imprimir etiqueta</span>
            </v-tooltip>
          </v-speed-dial>
        </v-toolbar>
        <v-container fluid style="max-height: 93vh" class="scrollDesign">
          <v-layout row wrap>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :rows-per-page-items="[10, 15, 25]"
                rows-per-page-text="Registros por página"
                :total-items="total"
                :items="people"
                :loading="working.wVisits"
                :pagination.sync="pagination"
                item-key="id"
                no-results-text="No se encontraron coincidencias"
                :no-data-text="
                  working.wVisits
                    ? 'Cargando'
                    : people.length > 0
                    ? ''
                    : 'No hay invitados'
                "
              >
<template v-slot:headers>
	<tr>
		<th class="text-xs-left" style="width: 100px; max-width: 100px; min-width: 100px;">
		<v-checkbox
		v-model="selectAll"
		:label="``"
		 color="red"
			@change="select_All()"
		 hide-details
		  class="pl-4"
			
		></v-checkbox>
        </th>
		<th class="text-xs-left" style="width: 200px; max-width: 200px; min-width: 200px;">
			Nombre
		</th>
		<th class="text-xs-left" style="width: 200px; max-width: 200px; min-width: 200px;">
			Apellidos
		</th>
		<th class="text-xs-left" style="width: 200px; max-width: 200px; min-width: 200px;">
			Correo
		</th>
		<th class="text-xs-left" style="width: 200px; max-width: 200px; min-width: 200px">
			Tipo
		</th>
		<th class="text-xs-center" style="width: 200px; max-width: 200px; min-width: 200px">
			&nbsp;
		</th>
	</tr>
</template>

<template v-slot:items="props">
	<tr>
		<td lass="text-xs-left" style="width: 100px; max-width: 100px; min-width: 100px;">
				<v-checkbox
		v-model="checkIdPreview"
		:label="``"
		:value="props.item.id"
		 color="red"
		 :multiple="true"
		 @change="getVisit(props.item)"
		  class="pl-4"
			hide-details
		></v-checkbox>
		</td>
		<td class="text-xs-left" style="width: 200px; max-width: 200px; min-width: 200px;">
			{{ props.item.parent ? props.item.parent.firstName : props.item.firstName }}
		</td>
		<td class="text-xs-left" style="width: 200px; max-width: 200px; min-width: 200px;">
			{{ props.item.parent ? props.item.parent.lastName : props.item.lastName }}
		</td>
		<td class="text-xs-left" style="width: 200px; max-width: 200px; min-width: 200px;">
			{{ (props.item.parent ? props.item.parent.email : "") || props.item.email }}
		</td>
		<td class="text-xs-left" style="width: 200px; max-width: 200px; min-width: 200px">
			{{props.item.type === "EXTERN" ? "Externo" : "Tutor"}}
		</td>
		<td class="text-xs-center" style="100%">
			<v-tooltip right>
				<v-btn @click="editVisit(props.item)" icon :disabled="!!props.item.idParent" slot="activator">
					<v-icon>edit</v-icon>
				</v-btn>
				<span>Editar</span>
			</v-tooltip>
	
			<v-tooltip right v-if="props.item.email==''">
				<v-btn @click="sendNotifications(props.item)" icon slot="activator" :disabled="true">
					<v-icon>send</v-icon>
				</v-btn>
				<span>Enviar invitación</span>
			</v-tooltip>
	
			<v-tooltip right v-else>
				<v-btn @click="sendNotifications(props.item)" icon slot="activator">
					<v-icon>send</v-icon>
				</v-btn>
				<span>Enviar invitación</span>
			</v-tooltip>
	
			<v-tooltip left>
				<v-btn @click="deleteVisitPerson(props.item)" icon slot="activator">
					<v-icon>delete</v-icon>
				</v-btn>
				<span>Eliminar</span>
			</v-tooltip>
	
			<v-tooltip left>
				<v-btn @click="generateEtiqueta(props.item)" icon slot="activator">
					<v-icon>print</v-icon>
				</v-btn>
				<span>Imprimir etiqueta</span>
			</v-tooltip>
	
			<v-tooltip style="display:none" left v-if="visit ? !visit.linkedPoll : null">
			</v-tooltip>
	
			<v-tooltip left v-else>
				<v-btn @click="detailPoll(props.item, props.item.id, isOpen)" icon :disabled="!props.item.pollAnsweredAt" slot="activator">
					<v-icon>visibility</v-icon>
				</v-btn>
				<span>Ver detalle encuesta</span>
			</v-tooltip>
	
			<v-tooltip style="display:none" left v-if="visit ? !visit.linkedPoll : null">
			</v-tooltip>
	
			<v-tooltip left v-else>
				<v-btn @click="downloadPoll(props.item)" icon :disabled="!props.item.pollAnsweredAt" slot="activator">
					<v-icon>download</v-icon>
				</v-btn>
				<span>Descargar encuesta</span>
			</v-tooltip>
		</td>
	</tr>
	
	<div style="margin-bottom:20px; margin-top:10px">
		<div v-for="(questions, i) in props.item.details" :key="i">
			<div v-show="openResponsePoll === props.item.id">
				<!--Respuestas-->
				<div class="customTable table-c" v-if="i == 0">
					<div class="item_a">
						<strong>Pregunta:</strong>
					</div>
	
					<div class="item_b">
						<strong>{{
																props.item.details[i].question
															}}</strong>
					</div>
					<div class="clear"></div>
				</div>
	
				<div class="customTable" v-if="i == 0">
					<div class="item_a">
						<strong>Respuesta:</strong>
					</div>
	
					<div class="item_b">
						<strong>Fecha y hora de creación:</strong>
					</div>
	
					<div class="item_c">
						<strong>Alerta</strong>
					</div>
					<div class="clear"></div>
				</div>
	
				<div class="customTable">
					<div class="item_a">
						{{ props.item.details[i].answer }}
					</div>
	
					<div class="item_b">
						{{ new Date( props.item.pollAnsweredAt ).toLocaleString() }}
					</div>
	
					<div class="item_c">
						<v-img v-if="props.item.details[i].alert" class="alertIcon" :src="require('@/assets/polls/icons/alerta3.png')" width="25px" height="25px" center></v-img>
						<v-img v-else class="alertIcon" :src="require('@/assets/polls/icons/alerta4.png')" width="25px" height="25px" center></v-img>
					</div>
	
					<div class="clear"></div>
				</div>
			</div>
		</div>
	</div>

</template>

<template v-slot:pageText="props">
	{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
	</v-data-table>
	<VisitPersonEditModal v-model="modals.editVisit" :visit="visit" :visitPerson="visitPerson" @cancelled="onCancel" @created="onNewVisitPerson" @updated="onEditVisitPerson" />
	<VisitPreviewTagModal v-model="modals.previewVisit" :visitPreview="visitPreview"  :visit="visit" :visitPerson="visitPerson" @cancelled="onCancel" :checkIdPreview="checkIdPreview" @reset-check="resetCheckBox"/>
	<LinkParent mode="selector" :class="modals.linkParent ? '' : 'position-no'" title="Añadir un tutor" :confirmDescription="
										'Los tutores seleccionados serán agregados a la cita ' +
											(visit ? visit.name : '---') +
											'. ¿Desea continuar?'
									" :student="visit ? visit.id : 0" :student-name="visit ? visit.name : ''" :std-parents="parents" :value="modals.linkParent" @linked="onLinkedParent" @close="onCancel" v-model="modals.linkParent" />
	
	<desition @desition="$event ? onConfirmNotify() : ''" v-model="modals.notify" title="Confirmar" description="Se enviarán notificaciones a los invitados. <br/> ¿Deseas continuar?" />
	
	<desition @desition="$event ? onDeleteVisitPerson() : ''" v-model="modals.confirmDelete" title="Eliminar invitado" description="¿Está seguro que desea realizar dicha acción, este proceso es irreversible y no podrá recuperar la información?" />
	
	<loading v-model="working.wLoading" text="Trabajando" />
	<success v-model="toast.success" text="Operación exitosa" />
	<error v-model="toast.failed" text="Ups ocurrió un error"/>
	<error v-model="toast.failedPreview" text="No has seleccionado ningún invitado para imprimir etiqueta"/>
	
	<error v-model="toast.copyError" text="No logramos copiar la liga de invitación" />
	<success v-model="toast.copySuccess" text="La liga de invitación ha sido copiada" />
	</v-flex>
	</v-layout>
	</v-container>
	</v-card>
	</v-dialog>
	
	<div data-app>
		<alerta v-model="modalsAlerts.alert" :text="modalsAlerts.Clave" :title="modalsAlerts.Title" :cond="modalsAlerts.Cond" @cancelled="onCancelAlert" @downloaded="onDownloadedType"></alerta>
	</div>
		
	</v-layout>
</template>

<script>
import DatePicker from "../../Tools/DatePicker";
import { funciones } from "../../../Mixins/Funciones";
import loading from "../../Dialogs/Loading";
import success from "../../Dialogs/Success";
import error from "../../Dialogs/Error";
import desition from "../../Dialogs/Confirm";
import VisitPersonEditModal from "../../Sections/Visits/VisitPersonEditModal";
import VisitPreviewTagModal from "../../Sections/Visits/VisitPreviewTagModal";
import LinkParent from "../../Modals/LinkParentModal";
import alerta from "./VisitSumaryAlert";
import { mapActions } from 'vuex';

export default {
	components: {
		DatePicker,
		loading,
		success,
		error,
		desition,
		VisitPersonEditModal,
		VisitPreviewTagModal,
		LinkParent,
		alerta,
	},
	mixins: [funciones],
	props: ["value", "visit", "haspoll"],
	data: () => ({
		
		selectAll: false,

		checkIdPreview: [],
		idPreview: null,
		pagination: {
			sortBy: "name",
		},
		filters: {
			search: "",
		},
		working: {
			wVisits: false,
			wLoading: false,
		},
		parents: [],
		checkedAll: [],
		toast: {
			success: false,
			failed: false,
			failedPreview: false,
			copyError: null,
			copySuccess: null,
		},
		modals: {
			notify: false,
			confirmDelete: false,
			editVisit: false,
			linkParent: false,
			previewVisit: false
		},
		modalsAlerts: {
			alert: false,
			Clave: "Elige el formato",
			Title: "Descargar respuestas de encuestas de citas",
			Cond: true,
		},
		search: "",
		startDateSearch: "",
		endDateSearch: "",
		total: 0,
		people: [],
		headers: [],
		visitPerson: null,
		visitPersonPreview: null,
		visitPreview: null,
		openResponsePoll: 0,
		isOpen: false,
		originalIndex: 0,
		url: "#",
		fileDowload: {
			file_type: "",
			id_visit_person: "",
		},
		typeDownloaded: "general",
		visitPersonAll: null
	}),
	watch: {
		value() {
			if (this.value) {
				this.$forceUpdate();
			}

			if (this.value && this.visit != null) {
				this.getVisitPeople(true);
			}
		},
		pagination: {
			handler() {
				if (!this.visit) {
					return;
				}
				this.filters.size = this.pagination.rowsPerPage;
				this.filters.offset =
					(this.pagination.page - 1) * this.pagination.rowsPerPage;
				this.getVisitPeople();
			},
			deep: true,
		},
	
	},
	computed: {
    hasAnyPollAnswer() {
      return this.people.some(p => p.pollAnsweredAt)
    }
	},
	methods: {
		...mapActions(["getToggleModalPreview",]),
		resetCheckBox(empty, resetAllCheck){
			this.checkIdPreview = empty
			this.selectAll = resetAllCheck
			this.visitPersonAll = null
		},
		select_All(){
			if(this.selectAll == true){
				let checkId = this.checkedAll.map((i) => i.id);
				this.checkIdPreview = checkId;
				let one = this.checkedAll[0];
				this.visitPersonAll = one;
			}else{
				this.checkIdPreview = []
			}
		},
		getVisit(visitPerson){
		this.visitPersonAll = visitPerson
		},

		generateAllEtiqueta(visitPerson){
			if(this.visitPersonAll !== null || this.checkIdPreview.length > 0){
				var offset = "";
			var pageSize = "";
			if (this.pagination.rowsPerPage !== undefined) {
				offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
				pageSize = this.pagination.rowsPerPage;
			} else {
				offset = 0;
				pageSize = 10;
			}
		
			var params = {
				search: this.filters.search,
				page_size: pageSize,
				offset: offset,
			};
				this.toast.failedPreview = false;
			this.visitPerson = this.visitPersonAll;
			this.modals.previewVisit = true;
				this.$store
				.dispatch("visits/getVisitsPeople", {
					id: this.visit.id,
					params: params,
				})
				.then((response) => {
					
						this.visitPreview = response.data;
					
					// this.working.wVisits = false;
				})
				.catch(() => {
					// this.working.wVisits = false;
				});
			}else{
				console.log("no se a seleccionado nada")
				this.modals.previewVisit = false;
				this.toast.failedPreview = true;
			}
		},











		generateEtiqueta: function(visitPerson) {
			
			var offset = "";
			var pageSize = "";
			if (this.pagination.rowsPerPage !== undefined) {
				offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
				pageSize = this.pagination.rowsPerPage;
			} else {
				offset = 0;
				pageSize = 10;
			}
		
			var params = {
				search: this.filters.search,
				page_size: pageSize,
				offset: offset,
			};
			this.visitPerson = visitPerson;
			this.modals.previewVisit = true;
			this.$store
				.dispatch("visits/getVisitsPeople", {
					id: this.visit.id,
					params: params,
				})
				.then((response) => {
					
						this.visitPreview = response.data;
					
					// this.working.wVisits = false;
				})
				.catch(() => {
					// this.working.wVisits = false;
				});
		},
		doCopy: function(visitPerson) {
			var message = this.url + "/visits/" + visitPerson.code;
			var self = this.toast;
			this.$copyText(message).then(
				function() {
					self.copySuccess = true;
				},
				function() {
					self.copyError = false;
				}
			);
		},
		detailPoll: function(visitPerson, id, open) {
			if (this.isOpen == false) {
				this.originalIndex = id;
				this.openResponsePoll = 0;
				this.openResponsePoll = id;
				this.isOpen = true;
			} else {
				if (this.originalIndex === id) {
					this.openResponsePoll = 0;
					this.isOpen = false;
				} else {
					this.originalIndex = id;
					this.openResponsePoll = 0;
					this.openResponsePoll = id;
					this.isOpen = true;
				}
			}
		},

		downloadPoll: function(visitPerson) {
			this.typeDownloaded = "single";
			this.modalsAlerts.alert = true;
			this.fileDowload.id_visit_person = visitPerson.id;
		},

		downloadPollGeneral: function() {
			this.typeDownloaded = "general";
			this.modalsAlerts.alert = true;
			this.fileDowload.id_visit_person = null;
		},

		onCancelAlert() {
			this.modalsAlerts.alert = false;
		},

		onDownloadedType(data) {
			/* if (this.typeDownloaded == "single") {
				console.log("Descarga Simple");
				this.onDownloaded(data);
			} else {
				console.log("Descarga General");
				this.onDownloaded(data);
			} */
			this.onDownloaded(data);
		},

		onDownloaded(file) {
			this.fileDowload.file_type = file;
      
			let fileType;
			if (file == "xlsx") fileType = ".xlsx";
			if (file == "pdf") fileType = ".pdf";

			this.$store
				.dispatch("visits/downloadPollResults", {
					id: this.visit.id,
					params: this.fileDowload,
				})
				.then((response) => {
					//console.log("response XXXX ***", response);
					var url = window.URL.createObjectURL(response.data);

					var url = window.URL.createObjectURL(response.data);
					var a = document.createElement("a");
					a.href = url;
					a.download = `EncuestaCitasInvitados${fileType}`;
					a.click();
					a.remove();
					setTimeout(() => window.URL.revokeObjectURL(url), 100);
					this.toast.success = true;
				})
				.catch((error) => {
					this.toast.failed = true;
					console.log(error);
				})
        .finally(() => {
					this.working.wLoading = false;
          this.onCancelAlert()
        });
		},


		getDateStartPoll(startDateDouble) {
			if (startDateDouble !== undefined) {
				return new Date(startDateDouble).toLocaleDateString("sv-SE");
			}
		},
		getDateEndPoll(endDateDouble) {
			if (endDateDouble !== undefined) {
				return new Date(endDateDouble).toLocaleDateString("sv-SE");
			}
		},
		getVisitPeople(forceUpdate) {
			var offset = "";
			var pageSize = "";
			if (this.pagination.rowsPerPage !== undefined) {
				offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
				pageSize = this.pagination.rowsPerPage;
			} else {
				offset = 0;
				pageSize = 10;
			}

			this.working.wVisits = true;
			var params = {
				search: this.filters.search,
				page_size: pageSize,
				offset: offset,
			};

			this.$store
				.dispatch("visits/getVisitsPeople", {
					id: this.visit.id,
					params: params,
				})
				.then((response) => {
					// console.log("respnse ***", response.data);
					this.working.wVisits = false;
					this.people = response.data.items;
					this.total = response.data.total;
					this.url = response.data.webAminUrl;
					this.checkedAll = response.data.items
					this.parents = response.data.items
						.map((el) => el.parent)
						.filter((el) => !!el);

					if (forceUpdate) {
						this.$forceUpdate();
					}
				})
				.catch(() => {
					this.working.wVisits = false;
				});
		},
		close() {
			this.$emit("onClosed", false);
		},
		filterSearch(clean) {
			if (!clean) {
				this.filters.search = this.search ? this.search : "";
			} else {
				this.filters.search = "";
			}
			if (!this.working.wVisits) {
				this.getVisitPeople(true);
			}
		},
		sendNotifications(person) {
			if (person) {
				this.onConfirmNotify(person);
			} else {
				this.modals.notify = true;
			}
		},
		onConfirmNotify(person) {
			this.working.wLoading = true;
			this.$store
				.dispatch("visits/notifyVisit", {
					id: this.visit.id,
					idVisitPerson: person ? person.id : undefined,
				})
				.then(() => {
					this.toast.success = true;
				})
				.catch(() => {
					this.toast.failed = true;
				})
				.finally(() => {
					this.working.wLoading = false;
				});
		},
		deleteVisitPerson(person) {
			this.person = person;
			this.modals.confirmDelete = true;
		},
		onDeleteVisitPerson() {
			this.working.wLoading = true;
			this.$store
				.dispatch("visits/deleteVisitPerson", {
					idVisit: this.visit.id,
					idVisitPerson: this.person.id,
				})
				.then((response) => {
					this.visit.peopleCount = response.data.peopleCount;
					this.$emit("onUpdate", response.data);

					this.working.wLoading = false;
					this.toast.success = true;
					this.getVisitPeople(true);
				})
				.catch(() => {
					this.toast.failed = true;
					this.working.wLoading = false;
				});
		},
		editVisit(visitPerson) {
			this.visitPerson = visitPerson;
			this.modals.editVisit = true;
		
		},
		onEditVisitPerson(success, visitPersonEdit) {
			this.modals.editVisit = false;
			if (success) {
				this.toast.success = true;
				this.toast.failed = false;

				this.people.splice(
					this.people.indexOf(this.visitPerson),
					1,
					visitPersonEdit
				);
				this.visitPerson = null;
				this.$forceUpdate();
			} else {
				this.toast.failed = true;
				this.toast.success = false;
			}
		},
		addVisitPerson() {
			this.modals.editVisit = true;
		},
		onNewVisitPerson(success, visitEdit) {
			this.modals.editVisit = false;
			if (success) {
				this.toast.success = true;
				this.toast.failed = false;

				this.visit.peopleCount = visitEdit.peopleCount;
				this.$emit("onUpdate", visitEdit);
				this.getVisitPeople(true);
			} else {
				this.toast.failed = true;
				this.toast.success = false;
			}
		},
		onCancel() {
			this.modals.editVisit = false;
			this.modals.confirmDelete = false;
			this.modals.notify = false;
			this.modals.linkParent = false;
			this.modals.previewVisit = false
			this.$forceUpdate();
		},
		linkParent() {
			this.modals.linkParent = true;
		},
		onLinkedParent(parents) {
			this.modals.linkParent = false;
			var ids = parents.map(function(parent) {
				return parent.id;
			});

			this.working.wLoading = true;
			this.$store
				.dispatch("visits/addVisitParents", {
					idVisit: this.visit.id,
					data: {
						parentIds: ids,
					},
				})
				.then((response) => {
					this.visit.peopleCount = response.data.peopleCount;
					this.$emit("onUpdate", response.data);

					this.working.wLoading = false;
					this.toast.success = true;
					this.getVisitPeople(true);
				})
				.catch(() => {
					this.toast.failed = true;
					this.working.wLoading = false;
				});
		},
		handleKeyDown(e) {
			//method to handle the keypress
			if (e.code === "Escape") {
				this.close();
			}
		},
	},
	created() {
		window.addEventListener("keydown", this.handleKeyDown); //will attach the event listener to the whole window when the component is created
		
	},
	destroyed() {
		window.removeEventListener("keydown", this.handleKeyDown); //will detach the event listener once the component is destroyed
	},
	mounted(){
	},
	
	
	filters: {},
};
</script>

<style>
.no-padding {
	padding: 0px !important;
}

.customTable {
	width: 83%;
	height: auto;
	margin-bottom: 10px;
	padding-left: 20px;
}

.table-c {
	padding-bottom: 20px !important;
	margin-bottom: 30px !important;
	border-bottom: solid 1px #ddd;
}

.customTable .item_a {
	width: 15%;
	height: auto;
	float: left;
}

.customTable .item_b {
	width: 20%;
	height: auto;
	float: left;
}

.customTable .item_c {
	width: 4%;
	height: auto;
	float: left;
	text-align: center;
}

.alertIcon {
	width: 20px;
	margin: 0 auto;
}

.clear {
	clear: both;
}

.custom_btn_close {
	position: absolute !important;
	right: 24px !important;
}
</style>


<style scoped>
.custom_tooltip {
	visibility: hidden;
	position: absolute;
	z-index: 2;
  color: white;
  font-size: 12px;
  background-color: #192733;
  border-radius: 10px;
  padding: 10px 15px 10px 15px;
	bottom: 0px;
	white-space: nowrap;
	width: min-content;
	height: max-content;
	top: 100%;
}
.custom_tooltip{
	font-size: 16px;
	margin-bottom: 8px;
}
.tooltip_trigger{
	height: 20px;
}
.tooltip_trigger:hover + .custom_tooltip{
	visibility: visible;
}
.custom_tooltip::before {
  content: "";
  position: absolute;
  transform: rotate(45deg);
  background-color: #192733;
  padding: 5px;
  top: -1%;
  left: 45%;
}
</style>